import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import Editor from 'react-simple-code-editor'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-json'
import 'prismjs/themes/prism-tomorrow.css'
import { createCommande } from '../../api/commande'

const defaultCommandePayload = {
	isTest: true,
	type_commande: 'mise-a-disposition',
	temporisation: 'immediat',
	missions: [
		{
			kilometrage: '200',
			notes: '',
			manutention_chauffeur: 'true',
			livraison: 'Entrepot/Magasin/Chantier',
			poids_total: '10',
			nature_chargement: 'vrac',
			type_transport: 'Véhicule léger',
			danger: 'false',
			assurance: 'false',
			adresse_debut: {
				value: {
					place_id: 'ChIJLTyNDYxv5kcRbtc9TZBbD_o',
					description:
						"Paris Beauvais Airport, Route de l'Aéroport, Tillé, France",
					latitude: 49.4553491,
					longitude: 2.1112384,
				},
				label: "Paris Beauvais Airport, Route de l'Aéroport, Tillé, France",
			},
			adresse_fin: {
				value: {
					place_id: 'ChIJHTtq-rF15kcRIoTbQ9feeJ0',
					description: 'Paris Orly Airport (ORY), Orly, France',
					latitude: 48.7299182,
					longitude: 2.3732304,
				},
				label: 'Paris Orly Airport (ORY), Orly, France',
			},
			date_debut: '17/06/2025',
			heure_debut: '16:00',
			heure_fin: '23:00',
			date_fin: '17/06/2025',
			taux_chargement: '10',
			heure_rippeur: '7:00',
			prix: 308,
			etage: 'RDC',
			escalier: false,
			ascenseur: false,
			nombre_dimension: '10',
			nombre_palettes: null,
			nature_palettes: null,
			type_transport_details: 'Fourgon 12m³',
			options_vehicule_leger: ['Frigorifique', 'Tall', 'Hayon'],
		},
	],
	ref_client: 'iahsiudhaiudhasiuhdasd',
	nom_signataire: 'aishiusahdiuhsad',
	prénom_signataire: 'aisuhdiuahda',
	email_signataire: 'samiramzi2000@gmail.com',
	téléphone1_signataire: '332',
	téléphone2_signataire: '332',
	manutention: ['Diable', 'Transpalette manuel', 'Sangle'],
	epi: [
		'Casque',
		'Gants',
		'Masque',
		'Lunettes',
		'Chaussure de sécurité',
		'Gilet de visibilité',
	],
	prix_original: 308,
	reduction: 0,
	prix: 308,
	clientID: '67f2e47d272cfdda8d2902e6',
	distance: 200,
}

const CommandeCreationTool = () => {
	const [isSubmitting, setIsSubmitting] = useState(false)
	const [result, setResult] = useState(null)
	const [payload, setPayload] = useState(
		JSON.stringify(defaultCommandePayload, null, 2)
	)
	const [isJsonValid, setIsJsonValid] = useState(true)
	const [authToken, setAuthToken] = useState('')

	useEffect(() => {
		try {
			JSON.parse(payload)
			setIsJsonValid(true)
		} catch (error) {
			setIsJsonValid(false)
		}
	}, [payload])

	const handleSendRequest = async () => {
		if (!isJsonValid) {
			toast.error('The payload is not valid JSON. Please correct it.')
			return
		}
		if (!authToken.trim()) {
			toast.error('Authentication Token is required.')
			return
		}

		setIsSubmitting(true)
		setResult(null)

		try {
			const parsedPayload = JSON.parse(payload)
			// **MODIFIED**: Use the token from state instead of localStorage
			const responseData = await createCommande(parsedPayload, authToken)
			toast.success('API request successful!')
			setResult({ status: 'success', data: responseData })
		} catch (error) {
			toast.error(error.message || 'An unknown error occurred.')
			setResult({ status: 'error', data: { message: error.message } })
		} finally {
			setIsSubmitting(false)
		}
	}

	const handleResetPayload = () => {
		setPayload(JSON.stringify(defaultCommandePayload, null, 2))
		toast.success('Payload has been reset to default.')
	}

	return (
		<div style={styles.container}>
			<p style={styles.description}>
				Provide an auth token, modify the JSON payload, and send the
				request.
			</p>
			<div style={styles.inputGroup}>
				<label htmlFor='authToken' style={styles.label}>
					Authentication Token (Bearer)
				</label>
				<input
					id='authToken'
					type='text'
					value={authToken}
					onChange={(e) => setAuthToken(e.target.value)}
					placeholder='Paste your access token here'
					style={styles.input}
				/>
			</div>
			<div style={styles.editorContainer}>
				<div style={styles.editorHeader}>
					<label style={styles.editorLabel}>
						Request Payload (Editable)
					</label>
					{!isJsonValid && (
						<span style={styles.jsonInvalid}>Invalid JSON!</span>
					)}
				</div>
				<Editor
					value={payload}
					onValueChange={(code) => setPayload(code)}
					highlight={(code) =>
						highlight(code, languages.json, 'json')
					}
					padding={10}
					style={styles.editor}
					textareaClassName='editor-textarea'
				/>
			</div>{' '}
			<div style={styles.buttonGroup}>
				<button
					onClick={handleResetPayload}
					style={styles.secondaryButton}
				>
					Reset to Default
				</button>
				<button
					onClick={handleSendRequest}
					style={
						isSubmitting || !isJsonValid
							? {
									...styles.submitButton,
									...styles.submitButtonDisabled,
								}
							: styles.submitButton
					}
					disabled={isSubmitting || !isJsonValid}
				>
					{isSubmitting ? 'Sending...' : 'Create Test Commande'}
				</button>
			</div>
			{result && (
				<div
					style={{
						...styles.resultBox,
						...(result.status === 'success'
							? styles.resultBoxSuccess
							: styles.resultBoxError),
					}}
				>
					<h3 style={styles.resultTitle}>
						{result.status === 'success'
							? 'Success Response'
							: 'Error Response'}
					</h3>
					<pre style={styles.preformattedResult}>
						<code>{JSON.stringify(result.data, null, 2)}</code>
					</pre>
				</div>
			)}
		</div>
	)
}

const styles = {
	container: { fontFamily: 'Montserrat, sans-serif' },
	description: { color: '#4b5563', lineHeight: 1.5, margin: '0 0 1.5rem 0' },
	inputGroup: {
		marginBottom: '1.5rem',
		display: 'flex',
		flexDirection: 'column',
	},
	label: {
		marginBottom: '8px',
		fontSize: '14px',
		color: '#374151',
		fontWeight: 500,
	},
	input: {
		width: '100%',
		padding: '0.75rem 1rem',
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '1rem',
		color: '#333',
		borderRadius: '8px',
		background: 'white',
		border: '1px solid #D9D9D9',
	},
	editorHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '0.5rem',
	},
	jsonInvalid: {
		color: '#ef4444',
		backgroundColor: '#fee2e2',
		padding: '0.2rem 0.5rem',
		borderRadius: '4px',
		fontSize: '0.8rem',
		fontWeight: 'bold',
	},
	editor: {
		fontFamily: '"Fira code", "Fira Mono", monospace',
		fontSize: 14,
		border: '1px solid #d1d5db',
		borderRadius: '8px',
		marginBottom: '10px',
		backgroundColor: '#1e293b',
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '1rem',
	},
	secondaryButton: {
		fontFamily: 'Montserrat, sans-serif',
		backgroundColor: 'transparent',
		border: '1px solid #d1d5db',
		color: '#4b5563',
		padding: '0.75rem 1rem',
		borderRadius: '8px',
		cursor: 'pointer',
		fontWeight: 500,
		flex: 1,
	},
	submitButton: {
		flex: 2,
		color: 'white',
		fontFamily: 'Montserrat, sans-serif',
		background: '#5BBCEA',
		border: 'none',
		padding: '0.75rem 1rem',
		cursor: 'pointer',
		fontWeight: 'bold',
		fontSize: '1rem',
		borderRadius: '8px',
		transition: 'background-color 0.2s ease',
	},
	submitButtonDisabled: {
		background: '#a0d8f0',
		cursor: 'not-allowed',
		opacity: 0.7,
	},
	resultBox: {
		marginTop: '1.5rem',
		borderRadius: '8px',
		padding: '1rem',
		borderLeftWidth: '4px',
		borderLeftStyle: 'solid',
	},
	resultBoxSuccess: { backgroundColor: '#f0fdf4', borderColor: '#22c55e' },
	resultBoxError: { backgroundColor: '#fef2f2', borderColor: '#ef4444' },
	resultTitle: { margin: '0 0 0.5rem 0', fontWeight: 600 },
	preformattedResult: {
		margin: 0,
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-all',
		fontSize: '0.875rem',
	},
}

export default CommandeCreationTool
